/**
 * Canonical property types used by marketplace filters and listing cards.
 * Values use hyphenated slugs stored in listings.property_type.
 */
export const PROPERTY_TYPE_OPTIONS = [
  { value: 'single-family', label: 'Single family' },
  { value: 'condo', label: 'Condo' },
  { value: 'townhouse', label: 'Townhome' },
  { value: 'multi-family', label: 'Multifamily' },
  { value: 'manufactured', label: 'Mobile home' },
  { value: 'land', label: 'Land' },
  { value: 'other', label: 'Other' },
] as const;

export type PropertyTypeValue = (typeof PROPERTY_TYPE_OPTIONS)[number]['value'];

const ALIASES: Record<string, PropertyTypeValue> = {
  'single-family': 'single-family',
  single_family: 'single-family',
  'single family': 'single-family',
  sfr: 'single-family',
  condo: 'condo',
  condominium: 'condo',
  townhouse: 'townhouse',
  townhome: 'townhouse',
  'town home': 'townhouse',
  'multi-family': 'multi-family',
  multi_family: 'multi-family',
  multifamily: 'multi-family',
  'multi family': 'multi-family',
  manufactured: 'manufactured',
  'mobile home': 'manufactured',
  mobile_home: 'manufactured',
  land: 'land',
  other: 'other',
  commercial: 'other',
};

export function normalizePropertyType(value: string | null | undefined): string {
  if (!value) return '';
  const key = value.trim().toLowerCase().replace(/[\s_]+/g, '-').replace(/-+/g, '-');
  const underscored = value.trim().toLowerCase().replace(/[\s-]+/g, '_');
  return (
    ALIASES[key] ??
    ALIASES[underscored] ??
    ALIASES[value.trim().toLowerCase()] ??
    key
  );
}

export function isKnownPropertyType(value: string): value is PropertyTypeValue {
  return PROPERTY_TYPE_OPTIONS.some((o) => o.value === value);
}
